import { useQuery } from '@tanstack/react-query'
import { customReportOptions } from './customReportOptions'

const useCustomReport = (id?: number, companyId?: string) => {
  const options = customReportOptions(id, companyId)
  return useQuery(options)
}

export default useCustomReport
